interface ReportSummaryCardsProps {
  totalExpected: number;
  totalScanned: number;
  flaggedCount: number;
  missingCount: number;
}

export function ReportSummaryCards({
  totalExpected,
  totalScanned,
  flaggedCount,
  missingCount,
}: ReportSummaryCardsProps) {
  const cards = [
    {
      label: 'Expected',
      value: totalExpected,
      color: 'text-gray-100',
      bgColor: 'bg-gray-700',
    },
    {
      label: 'Scanned',
      value: totalScanned,
      color: 'text-green-400',
      bgColor: 'bg-green-500/10',
    },
    {
      label: 'Flagged',
      value: flaggedCount,
      color: 'text-yellow-400',
      bgColor: 'bg-yellow-500/10',
    },
    {
      label: 'Missing',
      value: missingCount,
      color: 'text-red-400',
      bgColor: 'bg-red-500/10',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {cards.map(({ label, value, color, bgColor }) => (
        <div
          key={label}
          className={`${bgColor} rounded-lg p-4 border border-gray-700`}
        >
          <p className="text-sm text-gray-400">{label}</p>
          <p className={`text-3xl font-bold ${color}`}>{value}</p>
        </div>
      ))}
    </div>
  );
}
